import { useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

// Each usage bar reads its own key; the customer payload carries leads_limit, and turning a
// connector feature off disables that customer's connectors of the type.
const DEPENDENT_ON_FEATURES = [
  'features',
  'feature_changes',
  'contacts_quota',
  'contacts_phone_quota',
  'reveal_api_quota',
  'enrich_api_quota',
  'leads_limit',
  'leads_estimated_usage',
  'workflows',
]

export const useInvalidateAfterFeatureChange = () => {
  const customerId = useCustomerId()
  const queryClient = useQueryClient()

  return async () => {
    await Promise.all([
      // Exact, or this sweeps in code_check, domains, pages and users, none of which read features.
      queryClient.invalidateQueries({ queryKey: ['customer', customerId], exact: true }),
      ...DEPENDENT_ON_FEATURES.map(key => queryClient.invalidateQueries({ queryKey: ['customer', customerId, key] })),
      queryClient.invalidateQueries({ queryKey: ['weeklyReportsCredits', customerId] }),
    ])
  }
}
